import MARegSHOPage from './MARegSHOPage'
// Uncomment the below to migrate to stateful component
// import MARegSHOPageContainer from './MARegSHOPageContainer'

export { MARegSHOPage }
export default MARegSHOPage
// Uncomment the below to migrate to stateful component
// export { MARegSHOPageContainer }
// export default { MARegSHOPageContainer }
